<template>
  <div class="json-edit">
    <el-dialog :visible="value" :before-close="closeDialog">
      <vue-json-editor v-model="curJson" :show-btns="false" :expandedOnStart="true" @json-change="onJsonChange"
        mode="text"></vue-json-editor>
      <div style="margin-top: 20px; text-align: right;">
        <el-button type="primary" v-if="isImport" @click="importData">导入</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { updateAppAll } from '@/api/appRequest'
import vueJsonEditor from 'vue-json-editor'
export default {
  components: { vueJsonEditor },
  props: {
    json: Object,
    value: Boolean,
    isImport: Boolean
  },
  data() {
    return {
      curJson: '{}'
    }
  },
  mounted() {
    console.log(this.json);
    this.curJson = JSON.parse(JSON.stringify(this.json))
  },
  watch: {
    json(val) {
      this.curJson = JSON.parse(JSON.stringify(val))
    }
  },
  methods: {
    onJsonChange() {

    },
    closeDialog() {
      this.curJson = this.json
      this.$emit('input', false)
    },
    async importData() {
      const res = await updateAppAll({ json: JSON.stringify(this.curJson) })
      if (res.code === 0) {
        this.$message.success('导入成功')
      } else {
        this.$message.error('导入失败')
      }


      this.$emit('input', false)
    }
  }
}
</script>
<style>
.jsoneditor-vue {
  height: 500px;
}
</style>